export const getCountdownValue = (date?: Date) =>
  date ? Math.max(date.valueOf() - Date.now(), 0) : 0;
